import { useReportTemplateContext } from "../ReportTemplate/ReportTemplateContext";

const GREEN = "#04aa00";
const LIGHT_GREY = "#f0f0f0";
const WHITE = "#ffffff";

export default function MaaperaBlock() {
  const { rakennusData: kiinteisto } =
    useReportTemplateContext();

  const rakennukset =
    kiinteisto?.rakennukset_fulls ||
    kiinteisto?.rakennukset ||
    [];

  const allMaapera = rakennukset.flatMap(
    rakennus =>
      rakennus.aluetiedot?.maapera || []
  );

  // Poistetaan duplikaatit
  const uniqueMaapera = [];
  const seen = new Set();

  allMaapera.forEach(item => {
    const key =
      item.id ||
      `${item.x || ""}|${item.y || ""}`;

    if (!seen.has(key)) {
      seen.add(key);
      uniqueMaapera.push(item);
    }
  });

  return (
    <div
      className="rounded border overflow-hidden"
      style={{
        backgroundColor: WHITE,
        borderColor: "#e9f0ec"
      }}
    >
      <section>
        <div
          className="px-3 py-2 fw-bold text-white"
          style={{ backgroundColor: GREEN }}
        >
          Maaperän tila
        </div>

        <table className="table table-sm mb-0">
          <tbody>
            {uniqueMaapera.length > 0 ? (
              uniqueMaapera.map((item, index) => (
                <tr key={item.id || index}>
                  <th
                    className="px-3 py-2 fw-normal"
                    style={{
                      width: "65%",
                      backgroundColor:
                        index % 2 === 0
                          ? LIGHT_GREY
                          : WHITE,
                      border: 0
                    }}
                  >
                    Lähialueella on Maaperän tilan
                    tietojärjestelmään merkitty kohde
                  </th>

                  <td
                    className="px-3 py-2"
                    style={{
                      backgroundColor:
                        index % 2 === 0
                          ? LIGHT_GREY
                          : WHITE,
                      border: 0
                    }}
                  >
                    {item.etäisyys || "–"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={2}
                  className="px-3 py-2"
                  style={{
                    backgroundColor: WHITE,
                    border: 0
                  }}
                >
                  Lähialueella ei havaittu Maaperän tilan
                   MATTI-tietojärjestelmään merkittyjä kohteita.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </section>
    </div>
  );
}